// Exported so tile data outside this component can request "full width at every
// breakpoint" by setting colSpan to this ceiling — TileShell clamps colSpan down to
// the grid's actual resolved column count anyway, so a value at or above the max
// always fills the row regardless of the grid's configured `columns`.
export const MAX_GRID_COUNT = 12

export const clampCount = (value: number, max: number = MAX_GRID_COUNT): number => {
  const rounded = Number.isFinite(value) ? Math.round(value) : 1
  return Math.min(max, Math.max(1, rounded))
}

export type ResponsiveColumns = { sm: number; lg: number }

// Below `$tb-bp-lg` a tile is narrower than its own content at any count above one, so the
// sm tier is a single column whatever the board is configured for; lg tier = the target as-is.
export const getResponsiveColumns = (columns: number): ResponsiveColumns => ({
  sm: 1,
  lg: columns,
})
